export const NONCE_TYPE = {
  UPLOAD: "Upload",
  APPROVE: "Approval",
  RETRY: "Retry",
} as const;

export type NonceType = (typeof NONCE_TYPE)[keyof typeof NONCE_TYPE];
